export const DashboardPageView = 'dashboard';
